import { gql } from "@apollo/client";

export const GET_JOB_OPPORTUNITY_MATCH_STATS = gql`
  query GetJobMatchStats($jobId: ID!) {
    getJobOpportunity(id: $jobId) {
      matches(limit: 1000) {
        items {
          status
          subStatus
        }
      }
    }
  }
`;

export const GET_JOB_OPPORTUNITY_ASSESSMENTS = gql`
  query GetJobOpportunityAssessments($id: ID!) {
    getJobOpportunityAssessments(id: $id) {
      id
      name
      previewLink
      status
    }
  }
`;

export const SEARCH_ROPES_PROBLEMS = gql`
  query SearchRopesProblems($query: String!, $hideRopesTestBank: Boolean) {
    searchRopesProblems(query: $query, hideRopesTestBank: $hideRopesTestBank) {
      id
      isFromRopesTestBank
      previewLink
      status
      title
    }
  }
`;

export const GET_CANDIDATE_ASSESSMENTS_FOR_JOB = gql`
  query GetCandidateAssessmentsForJob($jobOpportunityId: ID!) {
    getCandidateAssessmentsForJob(jobOpportunityId: $jobOpportunityId) {
      user {
        email
        family_name
        given_name
        username
      }
      senderEmail
      assessmentResult {
        completedAt
        integrityReport {
          risk
        }
        previewLink
        score
        testName
      }
      assessmentTracking {
        status
        statusUpdatedAt
        testName
      }
    }
  }
`;

/** Same filter as getJobOpportunityUserInterests: not yet converted to a match. */
export const GET_JOB_WEB_APPLY_STATS = gql`
  query GetJobWebApplyStats(
    $jobOpportunityId: ID!
    $limit: Int = 1000
    $nextToken: String
  ) {
    listJobLongList(
      jobOpportunityId: $jobOpportunityId
      filter: { not: { convertedToMatch: { eq: true } } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        userId
      }
      nextToken
    }
  }
`;
